import Gender from '@/models/Shared/Gender';
import MaritalStatus from '@/models/Shared/MaritalStatus';
import VehicleAccessType from '@/models/Shared/VehicleAccessType';
import AvailabilityRestriction from '@/models/Workers/AvailabilityRestriction';
import VerifiableAttributeDto from '@/models/Workers/VerifiableAttributeDto';
import VerifiablePositionDto from '@/models/Workers/VerifiablePositionDto';
import WorkType from '@/models/Shared/WorkType';

export default class WorkerProfileDto {
    id: string;
    agencyId: string;
    legacyId: string;
    sequenceNumber = 0;
    status: string;
    firstName: string;
    lastName: string;
    fullName: string;
    emailAddress: string;
    mobilePhoneNumber: string;
    otherPhoneNumber: string;
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    latitude: number;
    longitude: number;
    biography: string;
    summary: string;
    previousExperience = '';
	dateOfBirth: Date               
	gender: Gender;                   
	maritalStatus: MaritalStatus;   
    nationality: string;       
    workTypes: WorkType[] = [];
    isDriver = false;
    maximumPassengers = 0;  
    isAgreedToMarketing = true;
    isUnspentConvictions = false;
    convictionDetails = '';
    availability: string[] = [];
    availabilityRestriction: AvailabilityRestriction.None;
    desiredAnnualSalary = 0;
    currentAnnualSalary = 0;
    currentPositionName = '';
    currentPositionCode = '';
    positions: VerifiablePositionDto[] = [];
    skills: VerifiableAttributeDto[] = [];
    qualifications: VerifiableAttributeDto[] = [];
    avatar = '';
    defaultDeskId = '';
    defaultDeskName = '';
    defaultBranchId = '';
    defaultBranchName = '';
    userId = '';
}